import type { Area } from 'react-easy-crop';

function loadImage(imageSrc: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (err) => reject(err));
    image.src = imageSrc;
    image.crossOrigin = 'anonymous';
  });
}

/** Renders `pixelCrop` from the image into a square JPEG suitable for circular avatar masking. */
export async function squareCropAreaToJpegFile(
  imageSrc: string,
  pixelCrop: Area,
  fileBaseName = 'profile'
): Promise<File> {
  if (pixelCrop.width < 2 || pixelCrop.height < 2) {
    throw new Error('Invalid crop dimensions');
  }
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Could not render image');
  }

  canvas.width = Math.round(pixelCrop.width);
  canvas.height = Math.round(pixelCrop.height);

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return new Promise<File>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Crop failed'));
          return;
        }
        resolve(new File([blob], `${fileBaseName}.jpg`, { type: 'image/jpeg' }));
      },
      'image/jpeg',
      0.92
    );
  });
}
